<template lang="pug">
  //- bDropSelector(
  //-   :options="options"
  //-   :value="value"
  //-   @change="$emit('change', $event)"
  //- )
  b-radio-btn(
    :options="options"
    :value="value"
    :rotate="rotate"
    @change="$emit('change', $event)"
  )
</template>

<script>
export default {
  name: "AlignEditor",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    rotate: false,
    options: {
      type: Array,
      default() {
        return [
          {
            label: "",
            value: "stretch",
            icon: "alignitems/stretch"
          },
          {
            label: "",
            value: "start",
            icon: "alignitems/start"
          },
          {
            label: "",
            value: "center",
            icon: "alignitems/center"
          },
          {
            label: "",
            value: "end",
            icon: "alignitems/end"
          }
        ];
      }
    },
    value: {
      type: String,
      default: "stretch"
    }
  }
};
</script>
